// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BuySection_wrapper__6zPP8"};